/* import __COLOCATED_TEMPLATE__ from './status-pill.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();